const navbar = () => {
    const nav = document.querySelector("nav")
    if (!nav) return
    const func = () => {
        if (window.scrollY >= 5) {
            nav.classList.add("scrolled")
        } else {
            nav.classList.remove("scrolled")
        }
    }
    func()
    window.addEventListener("scroll", func)
    nav.querySelector("[data-nav-toggle]")?.addEventListener("click", () => {
        nav.classList.toggle("open")
    })

    const dropdownContainers = Array.from(nav.querySelectorAll('.nav-dropdown-link'))
    dropdownContainers.forEach((dropdownContainer) => {
        const link = dropdownContainer.querySelector(':scope > .nav-link')
        const dropdown = dropdownContainer.querySelector('.nav-dropdown')
        const func = () => {
            dropdownContainer.setAttribute('dropdown-height', dropdown.getBoundingClientRect().height)
        }
        func()
        const observer = new ResizeObserver(func)
        observer.observe(dropdown)
        link.addEventListener("click", () => {
            let wasOpen = dropdownContainer.classList.contains('open')
            dropdownContainers.forEach((container) => {
                container.classList.remove('open')
                container.querySelector(':scope > .nav-link')?.setAttribute('aria-expanded', 'false')
            })
            if (!wasOpen) {
                dropdownContainer.classList.add('open')
                link.setAttribute('aria-expanded', 'true')
            }
        })

        dropdownContainer.addEventListener('focusin', () => link.setAttribute('aria-expanded', 'true'))
        dropdownContainer.addEventListener('focusout', (e) => {
            if (!dropdownContainer.contains(e.relatedTarget)) link.setAttribute('aria-expanded', 'false')
        })
        dropdownContainer.addEventListener('mouseenter', () => link.setAttribute('aria-expanded', 'true'))
        dropdownContainer.addEventListener('mouseleave', () => link.setAttribute('aria-expanded', 'false'))
    })
}

export default navbar
